import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

type LabelProps = {
  isRequired?: boolean;
  sx?: SxProps<Theme>;
};

export default function Label({
  children,
  isRequired,
  sx,
}: React.PropsWithChildren<LabelProps>) {
  const isString = typeof children === 'string';

  if (isString) {
    return (
      <Typography
        sx={[
          (theme) => ({
            color: theme.brandV2.colors.treadBlack,
            fontSize: '10px',
            fontWeight: 700,
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
        {isRequired ? ' *' : ''}
      </Typography>
    );
  }

  return children;
}
